import { createSlice } from '@reduxjs/toolkit'

const initialState = {
showPdf : false
}

export const pdfSlice = createSlice({
  name: 'pdf',
  initialState,
  reducers: {

    showPdf: (state) => {
      state.showPdf = !state.showPdf
    },
  },
})


export const { showPdf } = pdfSlice.actions

export default pdfSlice.reducer